/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
import dayjs from 'dayjs';
import moment from 'moment';
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setRegistrationFilter } from '../../../pages/RegistrasiMerchant/actions';
import { removeDuplicateDataAob } from '../../../utils/builder/common';
import { filterBuilder, rebuildDatesFilter } from '../../../utils/builder/registrationMerchant';
import { getRegional } from '../../../utils/storage';
import Filter from '../../elements/Filter';
import {
  fetchAgen, fetchCities,
  fetchDistricts, fetchProvinces,
  fetchRegionals, fetchSam, fetchSbm, fetchVillages
} from '../../layouts/PageBase/actions';
import { dataWave } from '../AktivasiManualFilter/constant';
import { Fields, defaultDateRange, initialValues } from './fields';
import styles from './styles.scoped.css';

function RegistrationFilter({ type }) {
  // const userData = getUserData();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [valueDate, setValueDate] = useState(defaultDateRange);
  const [maxDate, setMaxDate] = useState(new Date());
  const [minDate, setMinDate] = useState(dayjs(new Date()).add(-30, 'days').toDate());
  const [selectedTemp, setSelectedTemp]= useState({
    cityId: [],
    districtId: [],
    villageId: [],
    sbmId: []
  });

  const startDate = moment().subtract(6, 'day').toDate();
  const endDate = moment().toDate();
  const { dataFilter: values } = useSelector((state) => state.merchantRegistrations);
  const {
    dataRegionals, dataProvinces, dataCities, dataDistricts, dataVillages,
    dataAgents, dataSam, dataSbm,
    dataDetailUser: { regionalId, regionalName, provinceId, cityId, cities, districtId, sbm, sam },
  } = useSelector((state) => state.pageBase);

  const userRegion = getRegional();

  const query = queryString.parse(location.search.replace('?', ''));

  const dropdownData = {
    status: [{ value: '', label: 'Semua Status' }, { value: 'Gagal', label: 'Gagal' }, { value: 'Lengkap', label: 'Lengkap' }],
    regional: regionalId ? [{ label: regionalName, value: regionalId }] : [{ value: '*', label: 'Semua Regional' }, ...dataRegionals],
    provinces: [{ value: '*', label: 'Semua Provinsi' }, ...dataProvinces],
    cities: [
      { value: '*', label: 'Semua Kota/Kab' }, ...dataCities,
    ],
    districts: [{ value: '*', label: 'Semua Kecamatan' }, ...dataDistricts],
    villages: [{ value: '', label: 'Semua Kelurahan' }, ...dataVillages],
    waves: dataWave,
    agents: [{ value: '', label: 'Semua Agen' }, ...dataAgents],
    sam: sam?.id ? [{ value: sam?.id, label: sam?.name }] :[{ value: '*', label: 'Semua SAM' }, ...dataSam],
    sbm: sbm?.id ? [{ value: sbm?.id, label: sbm?.name }] : [{ value: '*', label: 'Semua SBM' }, ...dataSbm]
  };
  const handleGetAdministrativeArea = (name, params) => {
    if(name === 'agendId'){
      dispatch(fetchAgen());
    }

    const payloadProvince = {
      regional: params?.regional,
      samId: params?.samId
    };
    const payloadCity = {
      ...payloadProvince,
      provinceId: params?.provinceId,
      sbmId: params?.sbmId
    };
    const payloadDistrict = {
      ...payloadCity, cityId: params?.cityId
    };
    const payloadVillage = {
      ...payloadDistrict, districtId: params?.districtId
    };

    if(name === 'regional'){
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
      dispatch(fetchSbm(payloadProvince, selectedTemp.sbmId));
      dispatch(fetchSam({ regional: params?.regional }));
    }
    if(name === 'provinceId'){
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if(name === 'cityId'){
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
    if(name === 'districtId'){
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }

    if(name === 'sam'){
      dispatch(fetchSbm(payloadProvince, selectedTemp.sbmId));
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }

    if(name === 'sbm'){
      dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
    }
  };

  const handleChangeValuesDate = (value) => {
    const max = dayjs(new Date(value[0])).add(+30, 'days').toDate();
    const min = dayjs(new Date(value[0])).add(-30, 'days').toDate();

    setMaxDate(max > new Date()
      ? new Date
      : max);
    setMinDate(min);
  };

  const handleChangeValues = ({ name, value }) => {
    let filter = {};
    if(name === 'regional'){
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
        samId: sam?.id ? JSON.stringify([sam?.id]) : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : ''
      };
    }else if(name === 'provinceId'){
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        cityId: '',
        districtId: '',
        villageId: '',
        samId: sam?.id ? JSON.stringify([sam?.id]) : values.samId,
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : values.sbmId
      };
    }else if(name === 'cityId'){
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        districtId: '',
        villageId: '',
      };
      const originDataTemp = [...selectedTemp.cityId
        .filter(row => value.includes(row.value)),
      ...dataCities.filter(row => value.includes(row.value))];
      setSelectedTemp((val) => {
        return { ...val,
          cityId: removeDuplicateDataAob(originDataTemp, 'value') };
      });
    }else if(name === 'districtId'){
      filter = {
        ...values,
        [name]: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        villageId: '',
      };
      const originDataTemp = [...selectedTemp.districtId
        .filter(row => value.includes(row.value)),
      ...dataDistricts.filter(row => value.includes(row.value))];
      setSelectedTemp((val) => {
        return { ...val,
          districtId: removeDuplicateDataAob(originDataTemp, 'value') };
      });
    }else if(name === 'villageId'){
      filter = {
        ...values,
        [name]: value.length > 0 ? JSON.stringify(value) : '',
      };
      const originDataTemp = [...selectedTemp.villageId
        .filter(row => value.includes(row.value)),
      ...dataVillages.filter(row => value.includes(row.value))];
      setSelectedTemp((val) => {
        return { ...val,
          villageId: removeDuplicateDataAob(originDataTemp, 'value') };
      });
    }
    else if(name === 'sam'){
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        samId: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : '',
        provinceId: '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
    }else if(name === 'sbm'){
      filter = {
        ...values,
        regional: regionalId ? JSON.stringify([regionalId]) : values.regional,
        samId: sam?.id ? JSON.stringify([sam?.id]) : values.samId,
        sbmId: value !== '*' && value.length > 0 ? JSON.stringify(value) : '',
        cityId: '',
        districtId: '',
        villageId: '',
      };
      const originDataTemp = [...selectedTemp.sbmId
        .filter(row => value.includes(row.value)),
      ...dataSbm.filter(row => value.includes(row.value))];
      setSelectedTemp((val) => {
        return { ...val,
          sbmId: removeDuplicateDataAob(originDataTemp, 'value') };
      });
    }
    else{
      filter = { ...values, [name]: value };
    }

    const newQuery = queryString.stringify({
      ...query,
      // ...filter,
      regional: userRegion ?? '',
      ...filterBuilder(filter),
    });
    navigate(`?${newQuery}`);
    handleGetAdministrativeArea(name, filter);
    dispatch(setRegistrationFilter(filter));
  };

  const handleReset = () => {
    dispatch(
      setRegistrationFilter(
        { ...initialValues,
          regional: regionalId ? JSON.stringify([regionalId]) : '',
          provinceId: provinceId,
          cityId: cityId,
          districtId: districtId,
          samId: sam.id ? JSON.stringify([sam.id]) : '',
          sbmId: sbm.id? JSON.stringify([sbm.id]) : ''
        })
    );
    setValueDate(defaultDateRange);
    navigate('?');
  };

  const handleGetAgents = (e) => {
    dispatch(fetchAgen(e.target.value));
  };

  const handleSearchFilter = (value,name) => {
    if(regionalId !== undefined){
      const payloadProvince = {
        regional: regionalId ? JSON.stringify([regionalId]) : query?.regional,
        samId: sam?.id ? JSON.stringify([sam?.id]) : query?.samId
      };

      const payloadCity = {
        ...payloadProvince,
        provinceId: query?.provinceId?.length > 4 ? query?.provinceId : '',
        sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : query?.sbmId , search: value
      };
      const payloadDistrict = {
        ...payloadCity,
        cityId: query?.cityId?.length > 4 ? query?.cityId : ''
      };
      const payloadVillage = {
        ...payloadDistrict,
        districtId: query?.districtId?.length > 4 ? query?.districtId : ''
      };

      if(name === 'cities'){
        dispatch(fetchCities(payloadCity, selectedTemp.cityId));
      }
      if(name === 'districts'){
        dispatch(fetchDistricts(payloadDistrict, selectedTemp.districtId));
      }
      if(name === 'villages'){
        dispatch(fetchVillages(payloadVillage, selectedTemp.villageId));
      }
      if(name === 'sbm'){
        dispatch(fetchSbm({ ...payloadProvince, search: value }, selectedTemp.sbmId));
      }
    }
  };

  useEffect(() => {
    if(regionalId !== undefined){
      dispatch(fetchRegionals());
      dispatch(fetchAgen());
      const newQuery = rebuildDatesFilter(
        { startDate: startDate,
          endDate: endDate,
          regional: regionalId ? JSON.stringify([regionalId]) : '',
          provinceId: '',
          cityId: '',
          districtId: '',
          samId: sam?.id ? JSON.stringify([sam?.id]) : '',
          sbmId: sbm?.id ? JSON.stringify([sbm?.id]) : ''  });
      dispatch(setRegistrationFilter(newQuery));
      handleGetAdministrativeArea('regional', newQuery);
    }
  }, [regionalId]);

  return (
    <Filter
      className={styles.filterContainer}
      fields={
        Fields(
          { values, handleChangeValues,handleChangeValuesDate,handleGetAgents,
            dropdownData, regionalId, provinceId, cityId,
            cities, minDate, maxDate, type,handleSearchFilter,sbm, sam,
            valueDate, setValueDate
          }
        )
      }
      handleReset={handleReset}
    />
  );
}

export default RegistrationFilter;

RegistrationFilter.propTypes = {
  type: PropTypes.string
};

